var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h2V6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,6h-8V4h8c0.6,0,1,0.4,1,1S19.6,6,19,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8,1H6C5.4,1,5,1.4,5,2v6c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1V2C9,1.4,8.6,1,8,1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11h-2c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1v-6C15,11.4,14.6,11,14,11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19,16h-2v-2h2c0.6,0,1,0.4,1,1S19.6,16,19,16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h8V16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux);
export default __webpack_public_path__ + "static/media/uiux.0d47691f8aa8721c18f1a3d5e24ca607.svg";
export { ForwardRef as ReactComponent };